"use strict";

exports.__esModule = true;
exports.default = void 0;
var _locale = require("date-fns/locale");
var supportedLocales = {
  'en-US': _locale.enUS,
  en_US: _locale.enUS,
  'en-GB': _locale.enGB,
  en_GB: _locale.enGB,
  'en-AU': _locale.enAU,
  en_AU: _locale.enAU,
  es: _locale.es,
  fr: _locale.fr,
  'fr-CA': _locale.frCA,
  fr_CA: _locale.frCA,
  ar: _locale.ar
};
var _default = supportedLocales;
exports.default = _default;